<template>
  <v-layout row wrap justify-center align-center>
    <v-flex xs12>
      <v-card class="mb-2">
        <v-card-title class="text-xs-center" style="font-size: 2rem">Cadastro de projetos</v-card-title>
        <v-card-text>
          <v-layout row wrap justify-center align-center>
            <v-container fluid>
              <v-form v-model="valid" ref="form" lazy-validation>
                <v-flex xs12>
                  <v-text-field
                    label="*Nome"
                    v-model="projetoData.name"
                    :rules="[v => !!v || 'Nome é obrigatório']"
                    :counter="100"
                    maxlength="100"
                    required
                  ></v-text-field>
                  <v-select
                    v-if="!isMediador"
                    label="*Mediador"
                    :items="unidade.mediadores"
                    item-text="username"
                    :rules="[ value => value.length >= 1 || 'Mediador é obrigatório.']"
                    item-value="username"
                    v-model="moderador"
                    max-height="400"
                    hint="Escolha o responsável pelo projeto"
                    persistent-hint
                    required
                  ></v-select>
                  <v-select
                    v-if="alunos.length > 0"
                    label="Autores"
                    :items="alunos"
                    item-text="username"
                    item-value="id"
                    v-model="selectalunos"
                    max-height="400"
                    hint="Escolha os autores do projeto"
                    persistent-hint
                    multiple
                  ></v-select>
                  <div v-if="!isMakerlab">
                    <v-textarea
                      name="Descricao"
                      v-model="projetoData.description"
                      label="Descrição"
                      :counter="1200"
                      maxlength="1200"
                    ></v-textarea>
                    <v-textarea
                      name="Objetivo"
                      v-model="projetoData.objetivo"
                      label="Objetivo"
                      :counter="1200"
                      maxlength="1200"
                    ></v-textarea>
                    <v-textarea
                      name="justificativa"
                      v-model="projetoData.justificativa"
                      label="Justificativa"
                      :counter="1200"
                      maxlength="1200"
                    ></v-textarea>
                    <v-textarea
                      name="recursos"
                      v-model="projetoData.recursos"
                      label="Recursos"
                      :counter="1200"
                      maxlength="1200"
                    ></v-textarea>
                  </div>
                </v-flex>
                <v-layout row wrap>
                  <v-flex xs7>
                    <h2 class="mb-1">Escolha uma imagem para capa do projeto</h2>
                    <input
                      style="display: none"
                      type="file"
                      accept="image/*"
                      @change="onFileChanged"
                      ref="SelectFile"
                    >
                    <v-btn
                      style="margin-top: 15px"
                      color="blue-grey"
                      @click.native="$refs.SelectFile.click()"
                      class="white--text"
                    >Escolher imagem
                      <v-icon right dark>insert_photo</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex xs5>
                    <img
                      style="width:50%; height:100%; padding-top: 10px; display: none"
                      :src="path"
                      id="imagemprojeto"
                    >
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>
          </v-layout>
        </v-card-text>
        <v-card-actions>
        <v-layout align-center justify-end row fill-height>
          <v-btn color="primary" @click.native="$emit('prev')">voltar</v-btn>
          <v-btn color="primary" @click.native="proximo">Continuar</v-btn>
        </v-layout>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import api from '@/api';
export default {
  components: {},
  props: [
    'step1Data',
    'unidade'
  ],
  data () {
    return {
      projetoData: {},
      currentTab: 'Básico',
      showImageUpload: false,
      imageChangeModal: false,
      selectedFile: {},
      animation: false,
      tempData: {},
      selectalunos: [],
      moderador: {},
      mediadores: {},
      makerLab: false,
      alunos: [],
      options: {},
      logotipo: false,
      path: '',
      valid: true
    };
  },
  created () {},
  mounted () {
    this.$watch('step1Data', function () {
      if (this.step1Data.length !== null) {
        this.infoPadrao();
      }
    })
    api.request('GET', 'search-user?groups__name=Mediador').then(resp => {
      this.mediadores = resp.data;
    })
    this.$watch('moderador', function () {
      this.projetoData.moderador = this.moderador
      this.getStudents(this.projetoData.moderador)
    })
    this.$watch('unidade', function () {
      console.log(this.unidade)
    })
  },
  computed: {
    isMakerlab () {
      return this.$store.state.company.makerlab;
    },
    infoPadrao () {
      this.projetoData = this.step1Data;
      this.onFileImage();
    },
    isMediador () {
      this.seletor()
      return this.$store.state.selectedRole.name === 'Mediador'
    }
  },
  methods: {
    proximo () {
      if (this.$refs.form.validate()) {
        if (this.logotipo) {
          // this.projetoData.integrantes_pks = this.selectalunos
          this.$emit('dados2', this.projetoData);
          this.$emit('dadoAluno', this.selectalunos);
          this.$emit('dadoFoto', this.selectedFile);
          this.$emit('next');
        } else {
          // this.projetoData.integrantes_pks = this.selectalunos
          this.$emit('dados2', this.projetoData);
          this.$emit('dadoAluno', this.selectalunos);
          this.$emit('next');
        }
      }
    },
    seletor () {
      this.projetoData.moderador = this.$store.state.user.username
      this.getStudents(this.projetoData.moderador)
    },
    getStudents (mediador) {
      api
        .request('GET', 'search-user?mediador__username=' + mediador)
        .then(response => {
          this.alunos = response.data;
        });
    },
    getUserImage (username) {
      var userarray = this.projetoData.integrantes.filter(value => {
        return value.username === username;
      });
      return userarray[0].profilePic
    },
    clear () {
      this.$refs.form.reset()
    },
    base64 (element) {
      let self = this;
      var reader = new FileReader();
      reader.onloadend = function () {
        self.projetoData.image = reader.result;
      };
      reader.readAsDataURL(element);
    },
    onFileChanged (event) {
      this.selectedFile = event.target.files[0];
      this.logotipo = true;
      this.path = URL.createObjectURL(event.target.files[0]);
      var image = document.getElementById('imagemprojeto');
      image.style.display = 'block';
    },
    onFileImage () {
      var image = document.getElementById('imagemprojeto');
      image.src = this.projetoData.image;
      image.style.display = 'block';
    }
  }
};
</script>

<style >
</style>



// WEBPACK FOOTER //
// src/components/pages/Projetos/CadastroSteps/Step2.vue